<template>
  <v-dialog max-width="500px" v-model="inDialog" @click:outside="onClickOutside" persistent>
    <v-card>
      <v-form ref="viewPresentForm">
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px">{{
                $t(formCreateName)
              }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="position: absolute; right: 10px; top: 10px; color: #fff"
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-select
                  :items="teachers"
                  :label="$t('Tên giáo viên')"
                  v-model="item.teacherId"
                  name="teacherId"
                  item-value="id"
                  item-text="nameTeacher"
                  v-validate="'required'"
                  :data-vv-as="$t('Level')"
                  :error-messages="errors.first('Tên giáo viên')"
                  :disabled="false"
              />
            </v-flex>
            <v-flex xs12>
              <v-select
                  :items="dateteachingList"
                  :label="$t('Ngày có thể dạy')"
                  v-model="item.dateteaching"
                  name="degree"
                  v-validate="'required'"
                  item-value="value"
                  item-text="text"
                  :data-vv-as="$t('Trình độ')"
                  :error-messages="errors.first('Trình độ')"
              />
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12>
              <div style="font-weight: bold;margin: 10px;text-align: left;margin: 10px 0px">
                Khung thời gian học
              </div>
              <v-select height="40px"
                        :items="programs"
                        name="programTimeId"
                        item-value="programTimeId"
                        item-text="programTimeName"
                        chips
                        :multiple=true
                        v-model="item.programKeys"
                        :data-vv-as="$t('Khung thời gian học')"
                        :error-messages="errors.first('Khung thời gian học')"/>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>
      <div style="text-align: right">
        <v-btn color="primary" @click="onSave">
          <v-icon dark left>save</v-icon>
          {{ $t("lang.common.save") }}
        </v-btn>
        <v-btn color="error" @click="onCancel">
          <v-icon dark left>cancel</v-icon>
          {{ $t("lang.common.cancel") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {message} from "../../services";
import axios from "axios";
import {areaContants, cateContants} from "@/constants";
import moment from "moment/moment";

export default {
  name: "material-type-group-create",
  components: {message, axios},
  props: {
    propsItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    cDialog: {
      type: Boolean,
      default: false,
    },
    formCreateName: {
      type: String,
      default: '',
    },
    teachers: {
      type: Array,
      default: [],
    },
    clearable: {
      type: Boolean,
      default: false
    },
  },
  data: () => {
    return {
      dateteachingList: cateContants.dateteachingBabiPro,
      item: {
        teachersId: "",
        dateteaching: "",
        programs: "",
      },
      inDialog: false,
    };
  },
  watch: {
    propsItem: {
      handler(value) {
        //console.log(value);
        if (value !== null) {
          this.item = {
            teachersId: value.teachersId,
            dateteaching: value.dateteaching
                ? value.dateteaching
                : "",
            programKeys: value.programKeys
                ? value.programKeys
                : [],
          };
        } else {
          this.resetFrom();
        }
      },
      deep: true,
    },
    cDialog(value) {
      this.inDialog = value;
    },
    inDialog(value) {
      if (!value) {
        this.$emit("closeCreateDialog", "");
      }
    },
  },
  methods: {
    resetFrom: function () {
      this.item = {
        teacherId: "",
        dateteaching: "",
        programs: "",
      };
    },
    checkMinDate(minDate = moment()) {
      if (minDate == '' || minDate == null) minDate = moment();
      let minDate_tmp = moment(String(minDate));
      let today = moment();
      // if (minDate_tmp <= today) {
      //     minDate = moment().format('YYYY-MM-DD');
      // } else {
      minDate = minDate_tmp.format('YYYY-MM-DD');
      // }
      return minDate;
    },
    clearDropDate() {
      this.item.startDate = '';
    },
    onCancel: function () {
      this.$emit("closeCreateDialog", "");
    },
    onSave: function () {
      // console.log(this.item);
      this.$validator.validate().then((valid) => {
        if (!valid) {
          message.error(this.$t("lang.common.validate_fail"));
          return;
        }
        axios
            .post(
                process.env.VUE_APP_API_URL +
                "/kidFreeTime/save",
                this.item
            )
            .then(
                (data) => {
                  if (data.success) {
                    message.success(
                        this.$t("lang.common.save_success")
                    );
                    this.resetFrom();
                    this.onCancel();
                  } else {
                    let msg = data.description;
                    if (data.description === 'lang.category.duplicateCode') {
                      msg = 'lang.materialTypeGroup.duplicateCode';
                    } else if (data.description === 'lang.category.duplicateName') {
                      msg = 'lang.materialTypeGroup.duplicateCode';
                    }
                    message.error(this.$t(msg));
                  }
                },
                (error) => {
                  console.log(error);
                }
            );
      });
    },
    onClickOutside: function () {
      alert(1);
    },

  },
  created() {
    // Program
    axios.post(
        process.env.VUE_APP_API_URL + "/kidProgramTime/listAllName", {status: 1}
    )
        .then(
            (data) => {
              if (data.length > 0) {
                this.programs = data;
              }
            }
        );

    axios.post(
        process.env.VUE_APP_API_URL + "/kidTeacher/listAllName", {status: 1}
    )
        .then(
            (data) => {
              if (data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                  this.teachers.push(data[i]);
                }
              }
            }
        );
  },
};
</script>
